import { Plus } from 'lucide-react';
import { useState } from 'react';

import { useGetAllPolicies } from '~entities/policies/api/get-all-policies';

import { PolicyForm } from '~features/policies/ui/policy-form';

import Select from '~shared/components/select/select';
import { Button } from '~shared/shadcn/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~shared/shadcn/ui/dialog';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~shared/shadcn/ui/tooltip';

export interface PolicyOption {
  label: string;
  value: string;
}

export interface PolicySelectorProps {
  value: Array<PolicyOption>;
  onChange: (value: Array<PolicyOption> | undefined | null) => void;
}
export const PolicySelector = ({ value, onChange }: PolicySelectorProps) => {
  const [open, setOpen] = useState(false);
  const { data, isFetching } = useGetAllPolicies();
  const options = data?.map((policy) => ({
    label: policy.name,
    value: policy._id,
  }));

  return (
    <div className='flex items-center gap-2'>
      <Select
        className='flex-1'
        value={value}
        onChange={(option) => {
          const opt = option as Array<PolicyOption> | null | undefined;
          onChange(opt);
        }}
        isMulti
        placeholder='Select Policies'
        options={options}
        isLoading={isFetching}
      />

      <Dialog open={open} onOpenChange={setOpen}>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <DialogTrigger asChild>
                <Button variant={'outline'}>
                  <Plus />
                </Button>
              </DialogTrigger>
            </TooltipTrigger>
            <TooltipContent>
              <p>Add new policy</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
        <DialogContent className='max-w-fit'>
          <DialogHeader>
            <DialogTitle>Edit profile</DialogTitle>
            <DialogDescription>
              Create a new policy to be used in your organization.
            </DialogDescription>
          </DialogHeader>
          <div className='w-[786px]'>
            <PolicyForm
              onSuccess={(newPolicy) => {
                setOpen(false);
                onChange([
                  ...value,
                  { value: newPolicy.value, label: newPolicy.label },
                ]);
              }}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
